package navigation.settings.countries

import navigation.settings.countries.addeditcountry.AddEditCountryScreenModel
import navigation.settings.countries.allcountries.AllCountriesScreenModel
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val countryUiModule
    get() =
        module {
            factoryOf(::AllCountriesScreenModel)
            factoryOf(::AddEditCountryScreenModel)
        }